/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Error_Message_ShortInputs */

const en_contact_error_message_short = /** @type {(inputs: Contact_Error_Message_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please add a little more detail so we can prepare properly.`)
};

/**
* | output |
* | --- |
* | "Please add a little more detail so we can prepare properly." |
*
* @param {Contact_Error_Message_ShortInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_error_message_short = /** @type {((inputs?: Contact_Error_Message_ShortInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Error_Message_ShortInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_error_message_short(inputs)
});